/**
 * Adaptadores Fase 2 → hooks legacy (useEntitlements / moduleAccess).
 * TODO FASE 3: eliminar cuando todo consuma useCapabilities directamente.
 */
import { defaultEntitlements } from "@/modules/catalogModulos";

/** Mapea payload /auth/capabilities → forma useEntitlements. */
export function entitlementsStateFromCapabilities(capabilities) {
  if (!capabilities) return null;
  const compat = capabilities._compat || {};
  const perms = compat.module_permissions || {};
  // Preferir entitlements embebidos en module_permissions (fuente _owner_active_modules)
  // cuando el mapa plano de _compat.entitlements venga degradado por un parse erróneo.
  const fromPermsEnt =
    perms.entitlements && typeof perms.entitlements === "object" ? perms.entitlements : null;
  const fromCompatEnt =
    compat.entitlements && typeof compat.entitlements === "object" ? compat.entitlements : null;
  const entitlements = {
    ...defaultEntitlements(),
    ...(fromCompatEnt || {}),
    ...(fromPermsEnt || {}),
  };
  // Flags legacy alineados: si el backend marcó el módulo activo, no permitir que un
  // entitlement degradado bloquee la UI (isEntitlementActive prioriza el mapa).
  if (perms.modulo_asistente_laboral) entitlements.laboral = true;
  if (perms.modulo_gestion_despacho) entitlements.despacho = true;
  if (perms.modulo_visor_sat) entitlements.visor = true;
  if (perms.modulo_tramites_fiscales) entitlements.tramites = true;

  return {
    entitlements,
    modulo_visor_sat: Boolean(perms.modulo_visor_sat ?? entitlements.visor ?? true),
    modulo_asistente_laboral: Boolean(perms.modulo_asistente_laboral ?? entitlements.laboral),
    modulo_tramites_fiscales: Boolean(
      perms.modulo_tramites_fiscales ?? entitlements.tramites ?? entitlements.visor ?? true,
    ),
    modulo_gestion_despacho: Boolean(perms.modulo_gestion_despacho ?? entitlements.despacho),
    source: capabilities.platform?.is_platform_designer ? "platform_designer" : "capabilities",
    loading: false,
  };
}

/** Indica si un módulo (capabilities_key) está habilitado en capabilities.modules. */
export function isCapabilitiesModuleEnabled(capabilities, moduleKey) {
  if (!capabilities?.modules) return null;
  const row = capabilities.modules[moduleKey];
  if (!row) return null;
  return Boolean(row.enabled);
}
